import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { File } from './files/File.js';
export class Policy extends AutoEncoder {
    id;
    name = '';
    /**
     * Set either file or url for the policy. If both are set, the url has priority
     */
    file = null;
    url = null;
    get calculatedUrl() {
        if (this.url !== null) {
            return this.url;
        }
        return this.file?.getPublicPath() ?? '';
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Policy.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Policy.prototype, "name", void 0);
__decorate([
    field({ decoder: File, nullable: true, version: 25 })
], Policy.prototype, "file", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 25 })
], Policy.prototype, "url", void 0);
//# sourceMappingURL=Policy.js.map